<template>
  <div class="rightOuter">
    <div class="titlePart">授权书下载</div>
    <div class="bottomPart">
      <div class="leftInner">
        <img
          src="../../assets/images/download.png"
          alt=""
        />
        <div class="textPart">
          <div class="title">企业授权书模板</div>
          <div class="info">企业授权书模板等你来下载</div>
        </div>
      </div>
      <div class="rightInner">
        <el-button
          class="myMainButton"
          @click="yulan"
        >
          <!-- <a
            :href="baseUrl + '/my/授权书模板.pdf'"
            target="_blank"
          >预览</a> -->
          预览
        </el-button>
        <el-button
          type="primary"
          class="myPrimaryButton"
          @click="handleDown"
        >下载</el-button>
        <!-- <el-button type="info" class="myPrimaryButton">发送至邮箱</el-button> -->
      </div>
      <el-dialog
        :show-close="false"
        :visible.sync="showVisible"
        width="590px"
        :modal-append-to-body="false"
        :lock-scroll="false"
      >
        <img
          src="../../assets/images/sample.png"
          alt=""
        />
      </el-dialog>
    </div>
  </div>
</template>

<script>
import baseUrl from '@/api/baseUrl';
export default {
  data () {
    return {
      showVisible: false,
    }
  },
  methods: {
    showSample () {
      // this.showVisible = true;
    },
    yulan () {
      window.open(baseUrl + '/my/授权书模板.pdf')
    },
    // 下载时添加token
    handleDown () {
      const xhr = new XMLHttpRequest();
      xhr.open("get", this.baseUrl + "/api/v1/file/authFileTemp", true);  // get、post都可
      xhr.responseType = "blob";  // 转换流
      xhr.setRequestHeader("token", sessionStorage.getItem("token")); // token键值对
      xhr.onload = function () {
        if (this.status === 200) {
          const blob = this.response;
          const fileName = "企业授权书模板.pdf";
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            const a = document.createElement("a")
            const url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click()
            window.URL.revokeObjectURL(url)
          }
        }
      }
      xhr.send();
      // window.location.href = this.baseUrl + "/api/v1/file/authFileTemp";
    }
  }
}
</script>

<style lang="less" scoped>
.rightOuter {
  width: 100%;
  height: 800px;
  background: #fff;
  box-sizing: border-box;
  padding-top: 20px;
  font-size: 14px;
  border-radius: 6px;

  .titlePart {
    color: #2981ee;
    font-size: 24px;
    font-weight: bold;
    border-left: 6px solid #2981ee;
    padding-left: 20px;
    margin-bottom: 20px;
  }

  .bottomPart {
    padding: 20px 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .leftInner {
      display: flex;
      align-items: center;

      img {
        width: 60px;
        height: 60px;
        margin-right: 20px;
      }

      .textPart {
        display: flex;
        flex-direction: column;
        color: #2a2a2a;

        .title {
          font-weight: 550;
          font-size: 26px;
          margin-bottom: 6px;
        }

        .info {
          font-size: 16px;
        }
      }
    }

    .rightInner {
      display: flex;
      padding-right: 40px;
      button {
        margin-right: 16px;
      }
      .myMainButton {
        a {
          text-decoration: none !important;
          color: #2a2a2a;
        }
      }
    }
  }
}

/deep/ .el-dialog {
  border-radius: 8px;

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    width: 590px;
    height: 880px;
    padding: 0;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
  }
}
</style>
